
import { defineComponent } from "vue";

import { CBtn } from "../../vuetify-components";

export default defineComponent({
  components: { CBtn },
  mixins: [CBtn],
  props: {
    color: {
      type: String,
      default: "primary",
    },
    outlined: {
      type: [Boolean, String],
      default: true,
    },
    // ripple on button with inverting colors on hovor
    ripple: {
      type: Boolean,
      default: false,
    },
  },
});
